(() => {
  "use strict";

  if (window.__OPTI_PERSISTENCE_FIX_LOADED__) return;
  window.__OPTI_PERSISTENCE_FIX_LOADED__ = true;

  const ROOT_ID = "opti-chatbot";
  const CARDS_KEY = "opti_chat_product_cards_v1";

  function whenRootReady(callback) {
    const existing = document.getElementById(ROOT_ID);
    if (existing) return callback(existing);

    const observer = new MutationObserver(() => {
      const root = document.getElementById(ROOT_ID);
      if (!root) return;
      observer.disconnect();
      callback(root);
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  function normalizeDimensionText(raw) {
    let text = String(raw || "");

    text = text.replace(
      /\b(\d{3})\s*[/\-\s]\s*(\d{2})\s*[/\-\s]\s*[rR]?\s*(\d{2})\b/g,
      "$1/$2 R$3"
    );

    text = text.replace(
      /\b(\d{3})\s*\/\s*(\d{2})\s*[rR]\s*(\d{2})\b/g,
      "$1/$2 R$3"
    );

    return text.replace(/\s{2,}/g, " ").trim();
  }

  function install(root) {
    if (!root || root.dataset.persistenceFix === "true") return;
    root.dataset.persistenceFix = "true";

    const panel = root.querySelector(".opti-chat__panel");
    const messages = root.querySelector(".opti-chat__messages");
    const quickActions = root.querySelector(".opti-chat__quick-actions");
    const form = root.querySelector(".opti-chat__composer");
    const input = root.querySelector(".opti-chat__input");

    if (!panel || !messages || !quickActions || !form || !input) return;

    function saveProductCards() {
      const productBlocks = Array.from(messages.querySelectorAll(":scope > .opti-chat__products"));
      if (!productBlocks.length) return;

      try {
        sessionStorage.setItem(
          CARDS_KEY,
          JSON.stringify(productBlocks.slice(-2).map((node) => node.outerHTML))
        );
      } catch (_) {}
    }

    function restoreProductCards() {
      if (messages.querySelector(".opti-chat__products")) return;

      let saved = [];
      try {
        saved = JSON.parse(sessionStorage.getItem(CARDS_KEY) || "[]");
      } catch (_) {
        saved = [];
      }

      if (!Array.isArray(saved) || !saved.length) return;

      saved.forEach((html) => {
        if (typeof html !== "string" || !html.includes("opti-chat__products")) return;
        const holder = document.createElement("div");
        holder.innerHTML = html;
        const block = holder.firstElementChild;
        if (block && block.classList.contains("opti-chat__products")) {
          messages.appendChild(block);
        }
      });
    }

    const messageObserver = new MutationObserver(() => {
      if (messages.querySelector(".opti-chat__products")) saveProductCards();
    });

    messageObserver.observe(messages, { childList: true, subtree: true });

    const panelObserver = new MutationObserver(() => {
      if (!panel.hidden) restoreProductCards();
    });

    panelObserver.observe(panel, { attributes: true, attributeFilter: ["hidden"] });

    restoreProductCards();

    form.addEventListener(
      "submit",
      () => {
        const normalized = normalizeDimensionText(input.value);
        if (normalized && normalized !== input.value.trim()) {
          input.value = normalized;
          input.dispatchEvent(new Event("input", { bubbles: true }));
        }
      },
      true
    );

    const lang = String(document.documentElement.lang || (window.Shopify && window.Shopify.locale) || "fr").toLowerCase().split("-")[0];
    const seeds = {
      fr:{dimension:"Je cherche des pneus en ",auto:"Je cherche des pneus Auto en ",moto:"Je cherche des pneus Moto en ",winter:"Je cherche des pneus hiver en ",summer:"Je cherche des pneus été en ",all:"Je cherche des pneus 4 saisons en "},
      en:{dimension:"I am looking for tyres in ",auto:"I am looking for car tyres in ",moto:"I am looking for motorcycle tyres in ",winter:"I am looking for winter tyres in ",summer:"I am looking for summer tyres in ",all:"I am looking for all-season tyres in "},
      de:{dimension:"Ich suche Reifen in ",auto:"Ich suche Autoreifen in ",moto:"Ich suche Motorradreifen in ",winter:"Ich suche Winterreifen in ",summer:"Ich suche Sommerreifen in ",all:"Ich suche Ganzjahresreifen in "},
      es:{dimension:"Busco neumáticos en ",auto:"Busco neumáticos de coche en ",moto:"Busco neumáticos de moto en ",winter:"Busco neumáticos de invierno en ",summer:"Busco neumáticos de verano en ",all:"Busco neumáticos todo tiempo en "},
      it:{dimension:"Cerco pneumatici in ",auto:"Cerco pneumatici auto in ",moto:"Cerco pneumatici moto in ",winter:"Cerco pneumatici invernali in ",summer:"Cerco pneumatici estivi in ",all:"Cerco pneumatici quattro stagioni in "},
      nl:{dimension:"Ik zoek banden in ",auto:"Ik zoek autobanden in ",moto:"Ik zoek motorbanden in ",winter:"Ik zoek winterbanden in ",summer:"Ik zoek zomerbanden in ",all:"Ik zoek all-seasonbanden in "}
    };
    const S = seeds[lang] || seeds.fr;

    quickActions.addEventListener(
      "click",
      (event) => {
        const button = event.target.closest("button");
        if (!button) return;

        const text = button.textContent || "";
        let seed = "";

        if (/dimension|size|größe|medida|misura|maat/i.test(text)) seed = S.dimension;
        else if (/auto|car|coche/i.test(text)) seed = S.auto;
        else if (/moto|motorcycle|motorrad|motorband/i.test(text)) seed = S.moto;
        else if (/hiver|winter|invierno|invern/i.test(text)) seed = S.winter;
        else if (/été|ete|summer|sommer|verano|estate|zomer/i.test(text)) seed = S.summer;
        else if (/4 saisons|all-season|ganzjahr|todo tiempo|quattro stagioni/i.test(text)) seed = S.all;

        if (!seed) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        input.value = seed;
        input.dispatchEvent(new Event("input", { bubbles: true }));
        input.focus({ preventScroll: true });

        try {
          input.setSelectionRange(seed.length, seed.length);
        } catch (_) {}
      },
      true
    );
  }

  whenRootReady(install);
})();
